import settings from '../../settings';
let baseUrl = settings.apiBaseUrl;
export default {
    // Endpoints
    auth: {
        login: `${baseUrl}/api/v1/auth/login`,
        logout: `${baseUrl}/api/v1/auth/logout`,
        refresh: `${baseUrl}/api/v1/auth/refresh`,
        profile: `${baseUrl}/api/v1/auth/profile`,
        register: `${baseUrl}/api/v1/auth/register`,
    },
    categories: {
        get: `${baseUrl}/api/v1/dashboard/categories`,
        getFlat: `${baseUrl}/api/v1/dashboard/categories/flat`,
        getTree: `${baseUrl}/api/v1/dashboard/categories/tree`,
        getAttributes: `${baseUrl}/api/v1/dashboard/categories/attributes`,
        put: `${baseUrl}/api/v1/dashboard/categories/update`,
        post: `${baseUrl}/api/v1/dashboard/categories`,
        postTranslation: `${baseUrl}/api/v1/dashboard/categories/translation`,
        order: `${baseUrl}/api/v1/dashboard/categories/order`,
        delete: `${baseUrl}/api/v1/dashboard/categories`,
    },
    contents: {
        get: `${baseUrl}/api/v1/dashboard/contents`,
        getByCategorySlug: `${baseUrl}/api/v1/dashboard/contents/categories`,
        put: `${baseUrl}/api/v1/dashboard/contents/update`,
        post: `${baseUrl}/api/v1/dashboard/contents`,
        postAvailability: `${baseUrl}/api/v1/dashboard/contents/availability`,
        postTranslation: `${baseUrl}/api/v1/dashboard/contents/translation`,
        order: `${baseUrl}/api/v1/dashboard/contents/order`,
        delete: `${baseUrl}/api/v1/dashboard/contents`,
    },
    educators: {
        get: `${baseUrl}/api/v1/dashboard/educators`,
        getByCategorySlug: `${baseUrl}/api/v1/dashboard/educators/categories`,
        put: `${baseUrl}/api/v1/dashboard/educators/update`,
        post: `${baseUrl}/api/v1/dashboard/educators`,
        postAvailability: `${baseUrl}/api/v1/dashboard/educators/availability`,
        postTranslation: `${baseUrl}/api/v1/dashboard/educators/translation`,
        order: `${baseUrl}/api/v1/dashboard/educators/order`,
        delete: `${baseUrl}/api/v1/dashboard/educators`,
    },
    sliders: {
        get: `${baseUrl}/api/v1/dashboard/sliders`,
        put: `${baseUrl}/api/v1/dashboard/sliders/update`,
        post: `${baseUrl}/api/v1/dashboard/sliders`,
        postTranslation: `${baseUrl}/api/v1/dashboard/sliders/translation`,
        order: `${baseUrl}/api/v1/dashboard/sliders/order`,
        delete: `${baseUrl}/api/v1/dashboard/sliders`,
    },
    events: {
        get: `${baseUrl}/api/v1/dashboard/events`,
        getHavingForms: `${baseUrl}/api/v1/dashboard/events/having/forms`,
        put: `${baseUrl}/api/v1/dashboard/events/update`,
        post: `${baseUrl}/api/v1/dashboard/events`,
        postAvailability: `${baseUrl}/api/v1/dashboard/events/availability`,
        postTranslation: `${baseUrl}/api/v1/dashboard/events/translation`,
        order: `${baseUrl}/api/v1/dashboard/events/order`,
        delete: `${baseUrl}/api/v1/dashboard/events`,
    },
    books: {
        get: `${baseUrl}/api/v1/dashboard/books`,
        put: `${baseUrl}/api/v1/dashboard/books/update`,
        post: `${baseUrl}/api/v1/dashboard/books`,
        postTranslation: `${baseUrl}/api/v1/dashboard/books/translation`,
        order: `${baseUrl}/api/v1/dashboard/books/order`,
        delete: `${baseUrl}/api/v1/dashboard/books`,
    },
    podcasts: {
        get: `${baseUrl}/api/v1/dashboard/podcasts`,
        put: `${baseUrl}/api/v1/dashboard/podcasts/update`,
        post: `${baseUrl}/api/v1/dashboard/podcasts`,
        postAvailability: `${baseUrl}/api/v1/dashboard/podcasts/availability`,
        postTranslation: `${baseUrl}/api/v1/dashboard/podcasts/translation`,
        order: `${baseUrl}/api/v1/dashboard/podcasts/order`,
        delete: `${baseUrl}/api/v1/dashboard/podcasts`,
    },
    galleries: {
        get: `${baseUrl}/api/v1/dashboard/galleries`,
        put: `${baseUrl}/api/v1/dashboard/galleries/update`,
        post: `${baseUrl}/api/v1/dashboard/galleries`,
        postAvailability: `${baseUrl}/api/v1/dashboard/galleries/availability`,
        postTranslation: `${baseUrl}/api/v1/dashboard/galleries/translation`,
        order: `${baseUrl}/api/v1/dashboard/galleries/order`,
        delete: `${baseUrl}/api/v1/dashboard/galleries`,
    },
    settingsSliderHighlights: {
        get: `${baseUrl}/api/v1/dashboard/settings/highlights`,
        post: `${baseUrl}/api/v1/dashboard/settings/highlights`,
        order: `${baseUrl}/api/v1/dashboard/settings/highlights/order`,
        delete: `${baseUrl}/api/v1/dashboard/settings/highlights`,
    },

    settingsSliderPrograms: {
        get: `${baseUrl}/api/v1/dashboard/settings/programs`,
        post: `${baseUrl}/api/v1/dashboard/settings/programs`,
        order: `${baseUrl}/api/v1/dashboard/settings/programs/order`,
        delete: `${baseUrl}/api/v1/dashboard/settings/programs`,
    },

    settingsSliderInteresteds: {
        get: `${baseUrl}/api/v1/dashboard/settings/interesteds`,
        post: `${baseUrl}/api/v1/dashboard/settings/interesteds`,
        order: `${baseUrl}/api/v1/dashboard/settings/interesteds/order`,
        delete: `${baseUrl}/api/v1/dashboard/settings/interesteds`,
    },

    settingsSliderPodcasts: {
        get: `${baseUrl}/api/v1/dashboard/settings/podcasts`,
        post: `${baseUrl}/api/v1/dashboard/settings/podcasts`,
        delete: `${baseUrl}/api/v1/dashboard/settings/podcasts`,
    },

    form: {
        gsys: {
            get: `${baseUrl}/api/v1/dashboard/forms/gsys`,

            events: {
                get: `${baseUrl}/api/v1/dashboard/forms/gsys/events`,
            },
        },
        events: {
            get: `${baseUrl}/api/v1/dashboard/forms/events`,
            delete: `${baseUrl}/api/v1/dashboard/forms/events`,
        },
        eventTemplates: {
            get: `${baseUrl}/api/v1/dashboard/forms/events/templates`,
        },
        contacts: {
            get: `${baseUrl}/api/v1/dashboard/forms/contacts`,
        },
        newsletters: {
            get: `${baseUrl}/api/v1/dashboard/forms/newsletters`,
        },
        participants: {
            get: `${baseUrl}/api/v1/dashboard/forms/participants`,
            contents: `${baseUrl}/api/v1/dashboard/forms/participants/contents`,

        },
        explicitConsents: {
            get: `${baseUrl}/api/v1/dashboard/forms/explicit-consents`,
        },
    },

    eventTypes: {
        get: `${baseUrl}/api/v1/dashboard/event-types`,
    },
    categoryTypes: {
        get: `${baseUrl}/api/v1/dashboard/category-types`,
    },
    contentTypes: {
        get: `${baseUrl}/api/v1/dashboard/content-types`,
    },
    sliderLinkTypes: {
        get: `${baseUrl}/api/v1/dashboard/slider-link-types`,
    },
    galleryCategories: {
        get: `${baseUrl}/api/v1/dashboard/gallery-categories`,
    },
    upload: {
        file: `${baseUrl}/api/v1/dashboard/upload/file`,
        image: `${baseUrl}/api/v1/dashboard/upload/image`,
        imageByUrl: `${baseUrl}/api/v1/dashboard/upload/image/by-url`,

    },
    languages: {
        get: `${baseUrl}/api/v1/dashboard/languages`,
        put: `${baseUrl}/api/v1/dashboard/languages`,
        post: `${baseUrl}/api/v1/dashboard/languages`,
        order: `${baseUrl}/api/v1/dashboard/languages/order`,
        delete: `${baseUrl}/api/v1/dashboard/languages`,
    },
}